module.exports = __webpack_public_path__ + "img/imgZXGH(8).32a14032.png";